/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { User_global, Listing, SurveyData, LoanOfficer, LoanOfficerReview, MortgageQuestion, SMSOptIn, DisclosureDoc, RolloutOptions, CurbUser } from '../app.models';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, from, catchError, Observer, firstValueFrom, BehaviorSubject, Subject } from 'rxjs';
import { concatMap, map, toArray, first, mergeMap, filter, timeout, takeUntil } from 'rxjs/operators';
import { getFunctions, httpsCallable } from 'firebase/functions';

import { API, DEBUG_LOGS_KEY, DEBUG_LOG_STORE_STRATEGY, MAX_LOGS_IN_MB } from '../constants';
import { environment } from '../../environments/environment';
// import { rejects } from 'assert';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';

import {
  signOut, User,
  onAuthStateChanged, updateEmail, updatePassword, signInWithCustomToken
} from 'firebase/auth';
import { Subscription } from 'rxjs';
// import { traceUntilFirst } from 'firebase/performance';
import { setPersistence, indexedDBLocalPersistence, getAuth, signInWithEmailAndPassword, sendPasswordResetEmail, createUserWithEmailAndPassword } from 'firebase/auth';
import { DocumentReference, addDoc, collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, setDoc, updateDoc, where } from 'firebase/firestore';
import { WhoAmIResponse } from '../types/backend';
import { WithId } from '../types';

const REFRESH_TOKEN_INTERVAL = 30 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class AuthService {

  isLogging = false;


  public userId: string;
  public username: string;
  public phone: string;
  public userData; //: BehaviorSubject<User> = new BehaviorSubject(null);
  public userAuthToken: any;
  public userInitialized = false;
  public allMortgageQuestions: Array<any>;

  public restrictedRecommendStatesArray = [];
  public loadedProfileImage;
  public currentUser;
  private user: any;
  private userDisposable: Subscription | undefined;
  private authTokenInterval;
  private adminSyncTimeout;
  private lenderOverride = undefined;

  // Add these properties to your AuthService class:
  private destroy$ = new Subject<void>();
  private activeSubscriptions: Map<string, () => void> = new Map();

  userInitialized$ = new BehaviorSubject<boolean>(false);

  constructor(
    //  public auth: Auth,
    private http: HttpClient,
    private plt: Platform,
    private router: Router,
  ) {
  }

  public reinitialize() {
    console.log('AuthService reinitializing');
    this.destroy$ = new Subject<void>();

  }


  startUserSubscribe() {

    this.user = getAuth();
    // this.user = authState(this.auth);
    this.currentUser = this.user;
  }

  startTokenSubscription() {
    if (!this.plt.is('cordova')) {
      this.getAuthToken();
      clearInterval(this.authTokenInterval);
      this.authTokenInterval = setInterval(() => { this.getAuthToken(); }, REFRESH_TOKEN_INTERVAL);
    }
  }

  public async isLoggedIn(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const unsubscribe = onAuthStateChanged(getAuth(), (user: User | null) => {
        console.log('user logged in: ' + JSON.stringify(user));
        const isLoggedIn = !!user;
        console.log('isLoggedIn:', isLoggedIn);
        resolve(isLoggedIn);
        // Unsubscribe to the auth state changes once resolved
        unsubscribe();
      });
    });
  }

  async checkUserSession() {
    const user = await this.isLoggedIn();
    if (user) {
      console.log('user is logged in.');
      // do something
    } else {
      console.log('user session expired!');
      // do something else
    }
  }

  createAvatarName(name) {
    // console.log('get avatar name called: ' + name);
    if (name) {
      name = name.trim();
      if (name.includes(' ')) {
        const arr = name.split(' ');
        const newName = arr[0].charAt(0) + arr[1].charAt(0);
        return newName;
        //  return name.split(' ').map((n) => n[0]).join('');
      } else {
        return name.slice(0, 1);
      }
    }
    return '';
  }

  generateNewDocIds(count = 1): string[] {

    const db = getFirestore();

    const newDocIds = [];

    for (let i = 0; i < count; i++) {
      // Use the `doc()` method without providing an argument to generate a new document reference
      const newCollectionRef = collection(db, 'listings');
      const newDocRef = doc(newCollectionRef);

      // Add the auto-generated ID to the array
      newDocIds.push(newDocRef.id);
    }
    console.log('new doc ids generated: ', newDocIds);
    return newDocIds;
  }

  canLogout(): Promise<boolean> {
    if (!this.currentUser) {
      return Promise.resolve(true);
    }
    else {
      const firestore = getFirestore();
      const userDocRef = doc(firestore, `${API.users_endpoint}/${this.currentUser.uid}`);

      return getDoc(userDocRef)
        .then((snapshot) => !snapshot.metadata.fromCache && !snapshot.metadata.hasPendingWrites)
        .catch((error) => {
          console.error('Error retrieving user document:', error);
          return false;
        });
    }
  }

  public userDataObserver(): Observable<any> {
    const auth = getAuth();
    const firestore = getFirestore();

    return new Observable<any>((subscriber) => {
      let userDocUnsubscribe: (() => void) | null = null;

      const authUnsubscribe = onAuthStateChanged(auth, (user) => {
        // Clean up previous user doc listener
        if (userDocUnsubscribe) {
          userDocUnsubscribe();
          userDocUnsubscribe = null;
        }

        if (user) {
          this.currentUser = user;
          this.user = user;
          this.userId = user.uid;

          const userDocRef = doc(firestore, `${API.users_endpoint}/${user.uid}`);
          userDocUnsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
            const userData = docSnapshot.data();
            subscriber.next(userData);
          });
        } else {
          subscriber.next(null);
        }
      });

      // Store unsubscribe functions
      const subscriptionId = `userDataObserver_${Date.now()}`;
      this.activeSubscriptions.set(subscriptionId, () => {
        authUnsubscribe();
        if (userDocUnsubscribe) {
          userDocUnsubscribe();
        }
      });

      return () => {
        // Cleanup when observable is unsubscribed
        const cleanup = this.activeSubscriptions.get(subscriptionId);
        if (cleanup) {
          cleanup();
          this.activeSubscriptions.delete(subscriptionId);
        }
      };
    }).pipe(
      takeUntil(this.destroy$)
    );
  }


  public signInWithEmail(credentials): Promise<any> {
    const auth = getAuth();
    setPersistence(auth, indexedDBLocalPersistence);
    return signInWithEmailAndPassword(auth, credentials.email, credentials.password);
  }

  public signInWithToken(token): Promise<any> {
    const auth = getAuth();

    return signInWithCustomToken(auth, token)
      .then(userCredential => {
        // The user is now logged in
        return userCredential;
      })
      .catch(error => {
        console.error('Token login error:', error);
        throw error;
      });
  }

  public getFirebaseToken() {

    return new Promise((resolve, reject) => {

      this.currentUser = getAuth().currentUser;

      if (this.currentUser) {
        this.currentUser.getIdToken().then((idToken) => {
          resolve(idToken);
        });

      } else {
        reject(new Error('No user is signed in.'));
      }

    });
  }

  public forgotEmail(email) {
    const auth = getAuth();
    return sendPasswordResetEmail(auth, email);
  }

  public signUp(credentials) {
    const auth = getAuth();
    return createUserWithEmailAndPassword(auth, credentials.email, credentials.password);

  }

  public getAuthenticated(): boolean {
    return this.user !== null;
  }

  public getEmail() {
    return this.user && this.user.email;
  }

  public getUserAuthToken() {
    return this.userAuthToken;
  }

  public signOutUser(): Promise<void> {
    console.log('sign out called in auth.services');
    //  clearInterval(this.authTokenInterval);
    if (this.userDisposable) {
      this.userDisposable.unsubscribe();
    }

    this.user = null;
    this.userId = null;
    return signOut(getAuth());
  }

  public getUID(): string | null {
    const auth = getAuth();

    const cachedUID = localStorage.getItem('uid');
    if (cachedUID) {
      console.log('returning cached user: ' + cachedUID);
      return cachedUID;
    }

    // Check both currentUser and your internal tracking
    if (auth.currentUser && auth.currentUser.uid) {
      console.log('returning user: ' + auth.currentUser.uid);
      return auth.currentUser.uid;
    }

    // Fallback to any cached UID you might have
    return null;
  }

  public async waitForAuthReady(): Promise<void> {
    return new Promise((resolve) => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        console.log('Auth ready:', user ? user.uid : 'no user');
        unsubscribe();
        resolve();
      });

      // 3 second timeout fallback
      setTimeout(() => {
        unsubscribe();
        resolve();
      }, 3000);
    });
  }


  public getCurrentUser() {
    const auth = getAuth();
    return auth.currentUser;
  }


  public myAuthState(): Observable<any> {
    const auth = getAuth();

    return new Observable((subscriber) => {
      const currentUser = auth.currentUser;

      // Return early if there's already a current user
      if (currentUser) {
        console.log('Current user already exists:', currentUser.uid);
        this.user = currentUser;
        this.userId = currentUser.uid;
        this.currentUser = currentUser;
        subscriber.next(currentUser);
        subscriber.complete(); // Complete the observable since we have the user
        return () => { }; // Return empty cleanup function
      }

      // Set up the auth state listener for cases where no current user exists
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (!user) {
          console.log('There is no user logged in.');
          this.currentUser = null;
          subscriber.next(null);
        } else {
          console.log('Auth state changed - user found:', user.uid);
          this.user = user;
          this.userId = user.uid;
          this.currentUser = user;
          subscriber.next(user);
        }
      },
        (error: any) => {
          console.log('Error in my auth state: ' + error);
          this.currentUser = null;
          subscriber.error(error);
        });

      // Store unsubscribe function
      const subscriptionId = `myAuthState_${Date.now()}`;
      this.activeSubscriptions.set(subscriptionId, unsubscribe);

      return () => {
        const cleanup = this.activeSubscriptions.get(subscriptionId);
        if (cleanup) {
          cleanup();
          this.activeSubscriptions.delete(subscriptionId);
        }
      };
    }).pipe(
      takeUntil(this.destroy$)
    );
  }

  public cleanup() {
    console.log('AuthService cleanup - unsubscribing all Firebase listeners');

    this.destroy$.next();
    this.destroy$.complete();

    // Clean up any stored unsubscribe functions
    this.activeSubscriptions.forEach((unsubscribe, key) => {
      console.log(`Cleaning up subscription: ${key}`);
      unsubscribe();
    });
    this.activeSubscriptions.clear();

    // Clear intervals
    if (this.authTokenInterval) {
      clearInterval(this.authTokenInterval);
      this.authTokenInterval = null;
    }

    if (this.adminSyncTimeout) {
      clearTimeout(this.adminSyncTimeout);
      this.adminSyncTimeout = null;
    }
  }



  setUserDataInitialized(value: boolean) {
    this.userInitialized = value;
    this.userInitialized$.next(value);
  }

  getLenderOverride(): Promise<any> {
    return new Promise((resolve, reject) => {
      // if (this.lenderOverride !== undefined) {
      //   resolve(this.lenderOverride);
      // }

      this.subscribeFeatureLocks('userLocks').subscribe(
        res => {
          console.log('locks status is ' + JSON.stringify(res));
          const features = JSON.parse(JSON.stringify(res));

          if (features) {
            console.log('userFeatureLocks: ' + JSON.stringify(features));
            this.lenderOverride = features.lenderOverride;
          }
          resolve(this.lenderOverride);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  subscribeFeatureLocks(type: string): Observable<any> {
    return new Observable((observer) => {
      const auth = getAuth();

      if (auth.currentUser) {
        const firestore = getFirestore();

        const userUid = auth.currentUser.uid;

        const featureLocksRef: DocumentReference = doc(
          collection(firestore, `users/${userUid}/featureLocks`),
          type
        );

        getDoc(featureLocksRef)
          .then((docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              observer.next(data);
            } else {
              observer.next(null);
            }
          })
          .catch((error) => {
            observer.error(error);
          });
      }
    });
  }
  // Create profile for new user and store the data in database in doc id same with
  // id generated by Firebase Auth process
  // Called on user Sign Up
  public createUserAuth(credentials): Promise<any> {
    const auth = getAuth();

    return new Promise((resolve, reject) => {
      createUserWithEmailAndPassword(auth, credentials.email, credentials.password)
        .then((success) => {
          this.currentUser = success.user;
          resolve(success.user);
        })
        .catch((error) => reject(error));
    });
  }

  // RECREATE FAILED USER
  recreateUserInDB(): Promise<any> {
    if (this.userId) {
      console.log('RECREATING USER ' + this.userId);
      const firestore = getFirestore();
      const userDocRef = doc(firestore, `${API.users_endpoint}/${this.userId}`);
      return setDoc(userDocRef, { synced: new Date() }, { merge: true });
    } else {
      return Promise.reject('error in recreate account');
    }
  }

  // LAST LOGIN
  updateLoginDate(): Promise<any> {

    if (!this.currentUser) {
      this.currentUser = getAuth().currentUser;
    }

    if (this.currentUser && this.currentUser.uid) {
      console.log('updating login date for ' + this.currentUser.uid);
      const firestore = getFirestore();
      const userDocRef = doc(firestore, `${API.users_endpoint}/${this.currentUser.uid}`);
      const data = {
        lastLogin: new Date(),
        userAgent: navigator.userAgent + ' ' + environment.appversion
      };
      return setDoc(userDocRef, data, { merge: true });
    } else {
      return Promise.reject('error in last login date');
    }
  }

  updateInviteTimeStamp(): Promise<any> {
    if (!this.currentUser) {
      this.currentUser = getAuth().currentUser;
    }

    if (this.currentUser && this.currentUser.uid) {
      console.log('updateInviteTimeStamp for ' + this.currentUser.uid);
      const firestore = getFirestore();
      const userDocRef = doc(firestore, `${API.users_endpoint}/${this.currentUser.uid}`);
      const data = {
        lastInviteTimestamp: new Date()
      };
      return setDoc(userDocRef, data, { merge: true });
    } else {
      return Promise.reject('error in last login date');
    }
  }

  // update key-value in user data
  async updateUserDataProperty(keyValueObject): Promise<any> {
    console.log('updateUserDataProperty with :' + JSON.stringify(keyValueObject));
    try {
      const firestore = getFirestore();
      const userDocRef = doc(firestore, `${API.users_endpoint}/${this.currentUser.uid}`);

      await setDoc(userDocRef, keyValueObject, { merge: true });
      return Promise.resolve(this.currentUser);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //update user email
  //Important: this is a security sensitive operation that requires the user to have recently signed in. If this requirement isn't met, ask the user to authenticate again
  public updateUserEmail(newEmail: string, password: string): Promise<boolean> {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    return new Promise((resolve, reject) => {
      signInWithEmailAndPassword(auth, currentUser.email, password)
        .then((userCredential) => {
          updateEmail(userCredential.user, newEmail)
            .then(() => {
              this.updateUserDataProperty({ email: newEmail })
                .then(() => resolve(true))
                .catch((error) => reject(error));
            })
            .catch((error) => reject(error));
        })
        .catch((error) => reject(error));
    });
  }

  reAuthenticate(password: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        reject('No user is currently signed in.');
        return;
      }

      signInWithEmailAndPassword(auth, currentUser.email, password)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          if (errorCode === 'auth/wrong-password') {
            alert('Wrong password.');
          } else {
            alert(errorMessage);
          }
          console.log(error);

          reject();
        });
    });
  }

  //update user password
  //Important: this is a security sensitive operation that requires the user to have recently signed in. If this requirement isn't met, ask the user to authenticate again
  updateUserPassword(newPassword: string, password: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        reject('No user is currently signed in.');
        return;
      }

      signInWithEmailAndPassword(auth, currentUser.email, password)
        .then(() => {
          updatePassword(currentUser, newPassword)
            .then(() => {
              resolve(true);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // add new listing
  addListing(listing: any): string {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error('No user is currently signed in.');
    }

    console.log('add listing called for user: ' + currentUser.uid);

    const firestore = getFirestore();
    const listingCollection = collection(
      firestore,
      `${API.users_endpoint}/${currentUser.uid}/${API.listings_endpoint}`
    );

    let docId = doc(listingCollection);

    if (listing.pairedListingAgents.length && listing.pairedListingAgents[0].listingId) {
      const listingId = listing.pairedListingAgents[0].listingId;
      docId = doc(listingCollection, listingId);
    }

    console.log('docId created: ' + docId);

    setDoc(docId, listing, { merge: true });

    return docId.id;
  }

  listingUpdateObserver(listingId: string): Observable<any> {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error('No user is currently signed in.');
    }

    const firestore = getFirestore();
    const listingRef = doc(firestore, `${API.users_endpoint}/${currentUser.uid}/${API.listings_endpoint}/${listingId}`);

    return new Observable((observer: Observer<any>) => {
      const unsubscribe = onSnapshot(listingRef, (snapshot) => {
        observer.next(snapshot.data());
      });

      // Store unsubscribe function
      const subscriptionId = `listingUpdate_${listingId}_${Date.now()}`;
      this.activeSubscriptions.set(subscriptionId, unsubscribe);

      return () => {
        const cleanup = this.activeSubscriptions.get(subscriptionId);
        if (cleanup) {
          cleanup();
          this.activeSubscriptions.delete(subscriptionId);
        }
      };
    }).pipe(
      takeUntil(this.destroy$)
    );
  }

  async getRolloutOptions() {
    const db = getFirestore();

    const rolloutOptionsDoc = await getDoc(doc(db, API.backend_data, 'rolloutOptions'));
    return rolloutOptionsDoc.data() as RolloutOptions;
  };

  async getFeatureFlags(): Promise<any> {
    const db = getFirestore();

    return new Promise(async (resolve, reject) => {
      try {
        const featureFlagsRef = doc(db, API.backend_data, 'featureFlags');
        const featureFlagsSnap = await getDoc(featureFlagsRef);

        if (featureFlagsSnap.exists()) {
          console.log('featureFlags data is : ' + JSON.stringify(featureFlagsSnap.data()));
          resolve(featureFlagsSnap.data());
        } else {
          reject(new Error('No featureFlags document!'));
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  async getLoanOfficer(officerId: string): Promise<LoanOfficer> {
    console.log('get loan officer: ' + officerId);
    const firestore = getFirestore();
    const loanOfficerDocRef = doc(firestore, `${API.loanOfficers_endpoint}/${officerId}`);

    try {
      const loanOfficerSnapshot = await getDoc(loanOfficerDocRef);
      if (loanOfficerSnapshot.exists()) {
        console.log('loan officer doc is : ' + JSON.stringify(loanOfficerSnapshot.data()));
        return loanOfficerSnapshot.data() as LoanOfficer;
      } else {
        throw new Error('No loan officer document!');
      }
    } catch (error) {
      throw error;
    }
  }

  async getUserDoc(): Promise<any> {
    const firestore = getFirestore();

    if (!this.currentUser.uid) {
      this.currentUser.uid = this.getUID();
    }

    const userDocRef = doc(firestore, `${API.users_endpoint}/${this.currentUser.uid}`);

    try {
      const userDocSnapshot = await getDoc(userDocRef);
      if (userDocSnapshot.exists()) {
        // console.log('user doc response is : ' + JSON.stringify(userDocSnapshot.data()));
        return userDocSnapshot.data();
      } else {
        throw new Error('No user document was found!');
      }
    } catch (error) {
      throw error;
    }
  }

  async getMortgageKioskInfo(): Promise<MortgageQuestion> {
    const firestore = getFirestore();
    const mortgageQuestionRef = doc(firestore, `${API.backend_data}/MortgageQuestion`);

    try {
      const mortgageQuestionSnapshot = await getDoc(mortgageQuestionRef);
      if (mortgageQuestionSnapshot.exists()) {
        console.log('mortgageQuestion data is : ' + JSON.stringify(mortgageQuestionSnapshot.data()));
        return mortgageQuestionSnapshot.data() as MortgageQuestion;
      } else {
        throw new Error('No mortgageQuestion document!');
      }
    } catch (error) {
      throw error;
    }
  }

  async getSMSOptIn(): Promise<SMSOptIn> {
    const firestore = getFirestore();
    const smsOptInRef = doc(firestore, `${API.backend_data}/smsOptIn`);

    try {
      const smsOptInSnapshot = await getDoc(smsOptInRef);
      if (smsOptInSnapshot.exists()) {
        console.log('smsOptIn data is : ' + JSON.stringify(smsOptInSnapshot.data()));
        return smsOptInSnapshot.data() as SMSOptIn;
      } else {
        throw new Error('No smsOptIn document!');
      }
    } catch (error) {
      throw error;
    }
  }

  resetDynamicQRCode() {
    this.updateUserDataProperty({ qrCodeOnlylink: '' });
  }

  //update user password
  //Important: this is a security sensitive operation that requires the user to have recently signed in. If this requirement isn't met, ask the user to authenticate again
  async updateSMSOptIn(checked: boolean): Promise<any> {
    const firestore = getFirestore();
    const smsOptInRef = doc(firestore, `${API.backend_data}/smsOptIn`);
    const data = { isOptInChecked: checked };

    try {
      const result = await setDoc(smsOptInRef, data, { merge: true });
      return result;
    } catch (error) {
      throw error;
    }
  }

  // RESTRICTED STATES FOR LENDER RECOMMENDED FILTERING
  async restrictedRecommendStates(): Promise<any> {
    console.log('restrictedRecommendStates called!');
    const firestore = getFirestore();
    const statesRef = doc(firestore, `${API.backend_data}/restrictedRecommendStates`);

    try {
      const statesDoc = await getDoc(statesRef);
      if (statesDoc.exists()) {
        const statesData = statesDoc.data();
        console.log('restrictedRecommendStates data is: ' + JSON.stringify(statesData));
        return statesData;
      } else {
        throw new Error('No restrictedRecommendStates document!');
      }
    } catch (error) {
      throw error;
    }
  }

  getCustomMortgageKioskQuestions() {
    console.log('getCustomMortgageKioskQuestions called');

    const firestore = getFirestore();
    const customQuestionsCollection = collection(
      firestore,
      `${API.backend_data}/MortgageQuestion/CustomQuestions`
    );

    const customQuestionsQuery = query(customQuestionsCollection);

    return from(getDocs(customQuestionsQuery)).pipe(
      map((querySnapshot) => {
        const questionsArray = [];
        querySnapshot.forEach((doc1) => {
          const data = doc1.data();
          const id = doc1.id;

          const newQuestion = {
            id: data.id,
            active: data.active,
            question: data.question,
            yesAnswer: data.yesAnswer,
            noAnswer: data.noAnswer,
            default: data.default,
            style: data.style
          };
          questionsArray.push(newQuestion);
        });
        return questionsArray;
      })
    );
  }

  getDefaultMortgageQuestion(): any {
    const defaultQ = this.allMortgageQuestions.filter(q => q.default === true);
    return defaultQ[0];

  }

  getSpecificMortgageQuestion(id): any {

    const question = this.allMortgageQuestions.filter(q => q.id === id);
    return question[0];
  }

  assignRandomMortgageQuestion() {
    const randomQ = this.allMortgageQuestions[Math.floor((Math.random() * this.allMortgageQuestions.length))];

    console.log('random q is: ' + JSON.stringify(randomQ));
    User_global.assignedMortgageQuestionId = randomQ.id;
    this.updateUserDataProperty({ assignedMortgageQuestionId: randomQ.id });
  }

  async assignDefaultMortgageQuestion() {
    const defaultQ = this.allMortgageQuestions.filter(q => q.default === true);

    console.log('assigning default q : ' + JSON.stringify(defaultQ));

    if (User_global.assignedMortgageQuestionId === defaultQ[0].id) {
      return;
    }
    else {
      User_global.assignedMortgageQuestionId = defaultQ[0].id;
      await this.updateUserDataProperty({ assignedMortgageQuestionId: defaultQ[0].id });
    }
  }

  needsNewAssignedQuestion() {
    if (User_global.assignedMortgageQuestionId === undefined || User_global.assignedMortgageQuestionId === '') {
      return true;
    }
    else {
      const exists = this.allMortgageQuestions.filter(q => q.id === User_global.assignedMortgageQuestionId);
      console.log('existing q found: ' + JSON.stringify(exists));
      return !exists.length;
    }
  }

  isAssignedQuestionInvalid() {
    if (!User_global.assignedMortgageQuestionId) {
      return false;
    }

    const exists = this.allMortgageQuestions.filter(q => q.id === User_global.assignedMortgageQuestionId);
    console.log('existing q found: ' + JSON.stringify(exists));
    return !exists.length;
  }

  getEligibleLender(id): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log('get eligible lender: ' + id);

      if (!id) {
        reject('Missing lender id!');
      }

      const firestore = getFirestore();
      const eligibleLendersDocRef = doc(firestore, `${API.backend_data}/MortgageQuestion/EligibleLenders/${id}`);


      getDoc(eligibleLendersDocRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            console.log('eligible lender found: ' + JSON.stringify(snapshot.data()));
            resolve(snapshot.data());
          } else {
            reject('No eligible lender found!');
          }
        })
        .catch((error) => reject(error));
    });
  }

  getLoanOfficerReviews(officerId: string): Promise<Array<LoanOfficerReview>> {
    const firestore = getFirestore();
    const loanOfficerReviewsCollectionRef = collection(firestore, `${API.loanOfficers_endpoint}/${officerId}/reviews`);

    return new Promise((resolve, reject) => {
      getDocs(loanOfficerReviewsCollectionRef)
        .then((snapshot) => {
          if (!snapshot.empty) {
            const reviews: LoanOfficerReview[] = [];

            snapshot.forEach((doc1) => {
              const ratingArray = Array(doc1.data().averageRating).fill(null);

              reviews.push({
                averageRating: doc1.data().averageRating,
                reviewRatingStars: ratingArray,
                reviewCount: doc1.data().reviewCount,
                reviewScore: doc1.data().reviewScore,
                reviewSiteUrl: doc1.data().reviewSiteUrl,
                reviewSnippet: doc1.data().reviewSnippet,
                reviewSource: doc1.data().reviewSource,
                reviewIcon: doc1.data().reviewIcon
              });
            });

            console.log('reviews array: ' + JSON.stringify(reviews));
            resolve(reviews);
          } else {
            reject('No reviews document!');
          }
        })
        .catch((error) => reject(error));
    });
  }

  getLoanOfficerStates(): Promise<any> {
    console.log('getLoanOfficerStates ' + this.userId);

    if (!this.userId) {
      this.userId = this.getUID();
    }

    const firestore = getFirestore();
    const loanOfficerDocRef = doc(firestore, `${API.loanOfficers_endpoint}/${this.userId}`);

    return new Promise((resolve, reject) => {
      getDoc(loanOfficerDocRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            console.log('loan officer data is: ' + JSON.stringify(snapshot.data()));
            resolve(snapshot.data().states);
          } else {
            console.log('getLoanOfficerStates no loan officer');
            reject('No loan officer document!');
          }
        })
        .catch((error) => reject(error));
    });
  }

  getLoanOfficerByState(state): Observable<any> {
    const firestore = getFirestore();
    const loanOfficerCollectionRef = collection(firestore, API.loanOfficers_endpoint);
    const stateQuery = query(loanOfficerCollectionRef, where('states', 'array-contains', state));

    return from(getDocs(stateQuery)).pipe(
      map((lenders) => lenders.docs),
      mergeMap((lenders) =>
        from(lenders).pipe(
          concatMap((lender) => {
            try {
              const data: any = lender.data();
              const id = lender.id;
              return of({ id, ...data });
            } catch (ex) {
              console.log(ex);
              return of({});
            }
          }),
          toArray()
        )
      )
    );
  }

  async updateListing(listingRef, updatedListing) {
    const id = listingRef.id;

    console.log('update listing called for: ' + id + ' listing data ' + JSON.stringify(updatedListing) + ' listing ' + JSON.stringify(listingRef));
    return new Promise(async (resolve, reject) => {

      if (!id) {
        reject('No ID');
      }

      if (updatedListing.id) {
        delete updatedListing.id;
      }
      if (updatedListing.createdAt) {
        delete updatedListing.createdAt;
      }

      const firestore = getFirestore();
      const userUid = this.getUID();

      const listingDoc = doc(firestore, `${API.users_endpoint}/${userUid}/${API.listings_endpoint}/${id}`);

      // should not execute this for non paired listings

      if ((listingRef.loanOfficer && listingRef.loanOfficer !== 'updating')
        || (User_global.role === 'agentAdmin' && listingRef.loanOfficer !== 'updating')) {

        if (User_global.role === 'agentAdmin' && listingRef.agentAdmin) {
          console.log('User is admin and is assigned');
          this.syncListingWithAgent(id, updatedListing);

          // FORCE SYNC IF ADMIN
          if (this.adminSyncTimeout) {
            clearTimeout(this.adminSyncTimeout);
          }
          this.adminSyncTimeout = setTimeout(() => {
            const time = new Date();
            this.syncListingWithAgent(id, { synced: time });
          }, 10000);

          resolve(updatedListing);
        }

        if (User_global.role === 'lender' && listingRef.assignedByUser[0] === userUid) {
          console.log('User is lender and the listing was assigned by lender.');
          this.syncListingWithAgent(id, updatedListing);
          resolve(updatedListing);
        }

        if (User_global.role === 'agent' && listingRef.listingAgent === userUid && listingRef.agentAdmin) {
          console.log('User is primary agent.');
          this.syncListingWithAgent(id, updatedListing);
          //   return;
        }
      }

      setDoc(listingDoc, updatedListing, { merge: true })
        .then(() => {
          resolve(updatedListing);
        })
        .catch((error) => {
          this.logErrors('Error updating listing field: ' + JSON.stringify(updatedListing) + ' listing: ' + id + ' err: ' + error);
          console.log('failed to update listing ' + error);
          reject(error);
        });

    });
  }

  updateListingSuggestions(id, suggestions) {
    console.log('update listing suggestion called for: ' + id + ' listing data ' + JSON.stringify(suggestions));

    const firestore = getFirestore();
    const userUid = this.getUID();

    if (!id) {
      return;
    }

    const listingDoc = doc(firestore, `${API.users_endpoint}/${userUid}/${API.listings_endpoint}/${id}`);

    return new Promise((resolve, reject) => {
      const suggestionsDocRef = doc(collection(listingDoc, 'processedData'), 'suggestions');
      setDoc(suggestionsDocRef, suggestions, { merge: true })
        .then(() => {
          resolve(suggestions);
        })
        .catch((error) => {
          this.logErrors('Error updating listing field: ' + JSON.stringify(suggestions) + ' listing: ' + id + ' err: ' + error);
          console.log('failed to update listing ' + error);
          reject(error);
        });
    });
  }

  // ONLY FOR LENDER/ADMIN
  async syncListingWithAgent(id, changes) {

    try {
      console.log('syncListingWithAgent ' + id + ' changes ' + JSON.stringify(changes));
      // if (User_global.role === 'agent') {
      //   return;
      // }

      const functions = getFunctions();
      const syncAgentListing = httpsCallable(functions, 'syncAgentListing');
      syncAgentListing({ listingId: id, listingChanges: changes })
        .then((result) => {
          // Read result of the Cloud Function.
          /** @type {any} */
          const data = result.data;
          console.log('result from callable func ' + JSON.stringify(result));
          //  const sanitizedMessage = data.text;
        });
    }
    catch (err) {
      console.log('error in sync listing: ' + err);
    }
  }

  // ONLY FOR AGENT ADMIN
  async syncFeatureLocks(id, changes) {

    if (User_global.role !== 'agentAdmin') {
      return;
    }

    const functions = getFunctions();
    const saveAgentAdminFeatureLocks = httpsCallable(functions, 'saveAgentAdminFeatureLocks');
    saveAgentAdminFeatureLocks({ docId: id, userChanges: changes })
      .then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        const data = result.data;
        console.log('result from callable func ' + JSON.stringify(result));
        //  const sanitizedMessage = data.text;
      });
  }

  updateListingImages(id, updatedListing) {
    console.log('updateListingImages called for: ' + id);
    const imagesJSON: any = {};

    imagesJSON.listingImages = updatedListing.listingImages;
    imagesJSON.propertyImage = updatedListing.propertyImage;
    imagesJSON.hasPropertyImage = updatedListing.hasPropertyImage;

    console.log('updating listing images: ' + JSON.stringify(imagesJSON));

    const firestore = getFirestore();
    const userUid = this.getUID();

    const listingDoc = doc(firestore, `${API.users_endpoint}/${userUid}/${API.listings_endpoint}/${id}`);

    return new Promise((resolve, reject) => {
      setDoc(listingDoc, imagesJSON, { merge: true })
        .then(() => {
          resolve(updatedListing);
        })
        .catch((error) => {
          console.log('failed to update listing images ' + error);
          reject(error);
        });
    });
  }

  updateKioskTimestamp(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const firestore = getFirestore();
      const userUid = this.getUID();

      const listingDoc = doc(firestore, `${API.users_endpoint}/${userUid}/${API.listings_endpoint}/${id}`);


      if (!this.currentUser) {
        reject(false);
      }

      updateDoc(listingDoc, { kioskStarted: new Date() })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          console.log('failed to update listing ' + error);
          reject(error);
        });
    });
  }

  // delete listing // now archive
  deleteListing(id) {
    return new Promise((resolve, reject) => {

      if (User_global.role === 'agentAdmin') {
        this.syncListingWithAgent(id, { archived: true });
        resolve(true);
      }
      const firestore = getFirestore();
      const listingDoc = doc(firestore, `${API.users_endpoint}/${this.getUID()}/${API.listings_endpoint}/${id}`);

      setDoc(listingDoc, { archived: true }, { merge: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          this.logErrors('Error archiving listing field: ' + id + ' err: ' + error);
          console.log('failed to archive listing ' + error);
          reject(error);
        });

      // this.listingDoc.delete();
      // resolve(true);
    });
  }

  getDisclosures(): Promise<DisclosureDoc> {
    console.log('getDisclosures called');
    const firestore = getFirestore();
    const userUid = getAuth().currentUser.uid;

    const pdfCollectionRef = collection(firestore, `${API.users_endpoint}/${userUid}/disclosures`);
    const q = query(pdfCollectionRef, limit(1));

    return new Promise((resolve, reject) => {
      getDocs(q)
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            const firstDoc = querySnapshot.docs[0];
            resolve(firstDoc.data() as DisclosureDoc);
          } else {
            reject('No documents found!');
          }
        })
        .catch((error) => {
          console.log('error in pdf : ' + JSON.stringify(error));
          reject(error);
        });
    });
  }

  // get one listing from current user by its id
  getListingById(id: string): Promise<any> {

    console.log('getting listing by id ' + id);
    const firestore = getFirestore();
    const userUid = this.getUID();

    const listingDoc = doc(firestore, `${API.users_endpoint}/${userUid}/${API.listings_endpoint}/${id}`);

    return new Promise((resolve, reject) => {

      getDoc(listingDoc)
        .then((listingSnapshot) => {
          if (listingSnapshot.exists()) {
            resolve({ ...listingSnapshot.data(), id: listingSnapshot.id });
          } else {
            reject('No such document!');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // GET USER ANALYTICS FOR ONLY LINK
  getUserAnalytics(filter): Promise<any> {

    const userId = this.currentUser.uid;
    const headers = new HttpHeaders(
      {
        'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        Authorization: 'Basic ' + btoa(environment.useranalytics.user + ':' + environment.useranalytics.salt),
      });

    const range = filter;
    //    let body = `userid=${userId}&range=${range}`;

    const data = { userid: userId, range: range };
    const options = { headers: headers };

    console.log('getting analytics for user: ' + userId);

    return new Promise((resolve, reject) => {
      this.http.post(environment.useranalytics.url, data, { ...options, responseType: 'text' })
        .toPromise()
        .then((res) => {
          console.log('analytics res : ', res);
          resolve(res);
        })
        .catch((error) => {
          console.error('analytics err : ', error);
          reject(error.error.toString());
        });
    });
  }


  // GET USER ANALYTICS FOR ONLY LINK
  async getRolloutToken(): Promise<any> {

    const userId = this.currentUser.uid;
    const headers = new HttpHeaders(
      {
        'Access-Control-Allow-Headers': 'Content-Type',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json'
        //   Authorization: 'Basic ' + btoa(environment.useranalytics.user + ':' + environment.useranalytics.salt),
      });


    const data = { userId: userId };
    const options = { headers: headers };

    console.log('getting rollout token for user: ' + userId);

    return new Promise((resolve, reject) => {
      this.http.post(environment.rollout_token_url, data, { ...options, responseType: 'text' })
        .toPromise()
        .then((res) => {

          resolve(res);
        })
        .catch((error) => {
          console.error('rollout err : ', error);
          reject(error.error.toString());
        });
    });
  }

  // LOG USER INFO ON THE BACKEND
  async logClientInfo(log): Promise<any> {

    return new Promise((resolve, reject) => {
      console.log('trying to log info: ' + log);
      let userId = '';

      // DONT SEND THIS REPETITIVE LOG
      if (log.indexOf('INTERNAL ASSERTION FAILED') > -1) {
        console.log('INTERNAL ASSERTION FAILED');
        resolve(true);
      }

      if (this.currentUser && this.currentUser.uid) {
        userId = this.currentUser.uid;
      }

      const headers = new HttpHeaders(
        {
          'Access-Control-Allow-Headers': 'Content-Type',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json'
        });

      const message = ' ' + new Date() + ' -- ' + ' UserID: ' + userId + ' User-agent header sent: '
        + navigator.userAgent + ' app ver: ' + environment.appversion
        + ' -- ' + ' platform: ' + JSON.stringify(this.plt.platforms()) + ' -- ' + log;

      const data = { client_log: message };

      const options = { headers: headers };

      console.log('logging for user: ' + userId);


      this.http.post(environment.log_errors, data, { ...options, responseType: 'text' })
        .toPromise()
        .then((res) => {
          console.log('client log success : ', res);
          resolve(res);
        })
        .catch((error) => {
          console.error('client log fail : ', error);
          reject(error.error.toString());
        });
    });
  }

  // LOG USER ERRORS ON THE BACKEND
  async logErrors(error, severe = false): Promise<any> {
    this.saveLogToLocalStorage(severe ? 'Error Severe' : 'Error', [error])

    const self = this;

    const errorMessagesToIgnore = [
      'INTERNAL ASSERTION FAILED',
      'Max retry time for operation exceeded'
    ];

    if (errorMessagesToIgnore.includes(error)) {
      // Ignoring the error, so return early
      return;
    }


    if (self.isLogging) {
      setTimeout(() => { self.logErrors(error, severe); }, 2000); // add retry
      return; // If already logging, exit
    }

    self.isLogging = true; // Set logging flag

    console.error('trying to log error: ' + error);
    let userId = '';

    //  this.currentUser = firebase.auth().currentUser;

    if (this.currentUser && this.currentUser.uid) {
      userId = this.currentUser.uid;
    }

    const headers = new HttpHeaders(
      {
        'Access-Control-Allow-Headers': 'Content-Type',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json'
      });

    const message = ' ' + new Date() + ' -- ' + ' UserID: '
      + userId + ' User-agent header sent: '
      + navigator.userAgent + ' -- '

      + ' device size: '
      + ' window.innerWidth ' + window.innerWidth
      + ' window.innerHeight ' + window.innerHeight
      + ' window.devicePixelRatio ' + window.devicePixelRatio
      + ' this.plt.width() ' + this.plt.width()
      + ' this.plt.height() ' + this.plt.height()

      + ' app ver: ' + environment.appversion + ' -- '
      + ' platform: ' + JSON.stringify(this.plt.platforms()) + ' -- '
      + error;

    const data = { client_error: message, severe_error: severe };
    const options = { headers: headers };

    console.log('logging error for user: ' + userId);

    // Reset logging flag after a delay (throttling)
    setTimeout(() => {
      self.isLogging = false;
    }, 250); // Adjust the delay as needed

    return new Promise((resolve, reject) => {
      this.http.post(environment.log_errors, data, { ...options, responseType: 'text' })
        .toPromise()
        .then((res) => {
          console.log('error log success : ', res);
          resolve(res);
        })
        .catch((err) => {
          console.error('error 2 log fail : ', error);
          reject(err);
        });
    });
  }

  // LOG USER ERRORS ON THE BACKEND
  contactLookup(contact): Promise<any> {
    const self = this;
    console.log('trying to get contact user: ' + contact);

    return new Promise((resolve, reject) => {
      //  firebase.auth().currentUser.getIdToken().then(idToken => {
      this.currentUser.getIdToken().then((idToken) => {
        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          lead: contact
        });

        console.log('sending data: ' + JSON.stringify(data));

        self.http.post(environment.contactLookup, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('contact lookup response: ', res);
            resolve((<any>res));
          })
          .catch((error) => {
            console.error('contact lookup err : ', error);
            reject(error);
          });
      }).catch(error => {
        console.log('contact lookup err 2 : ' + error);
        reject(error);
        // Handle error
      });
    }).catch(error => {
      console.log('contact lookup err 3: ' + error);
      // reject(error);
      // Handle error
    });
  }

  // SAVE LEAD FROM SERVER
  async serverLeadSave(docId, guestData) {

    try {
      //  console.log('serverLeadSave called with id ' + docId);
      const auth = getAuth();
      this.currentUser = auth.currentUser;

      //  console.log(`Creating lead via web ${this.currentUser?.accessToken} with credentials: ${JSON.stringify(guestData)}`);
      //  console.log(`Sending data: ${guestData}`);

      // temp save doc ID like this
      guestData.guestId = docId;

      const response = await this.http
        .post<{ message: string, guestId }>(
          environment.saveLead,
          guestData,
          { headers: this.getHeaders() }
        )
        .toPromise();


      console.log('Saving lead web response: ', response);
      this.logClientInfo('Saving lead web response: ' + JSON.stringify(response));

      return response;
    } catch (error) {
      console.error('Saving lead web  error: ', error);
      this.logErrors('Error Saving lead web : ' + JSON.stringify(error.stack) + '\nMessage: ' + error.message);
      throw error;
    }
  }

  // Database related
  createUserInDB(credentials, userId: string): Promise<any> {

    credentials.createdAt = new Date();
    delete credentials.password;

    const firestore = getFirestore();
    //  const userUid = this.currentUser.uid;
    const userCollection = collection(firestore, `${API.users_endpoint}`);
    const userDoc = doc(userCollection, userId);

    return setDoc(userDoc, credentials)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        this.logErrors('Error field: ' + userId + ' err: ' + error);
        console.log('error in user ' + error);
        console.log('error in create user: ' + error);
      });
  }

  // create user in db via server
  async createUserDBWeb(credentials, user): Promise<any> {

    delete credentials.password;

    // Reviews not needed for agents
    if (credentials.role === 'agent') {
      delete credentials.reviews;
    }

    const auth = getAuth();
    this.currentUser = auth.currentUser;

    console.log(`Creating user via web ${user} with credentials: ${JSON.stringify(credentials)}`);

    try {
      const idToken = await this.currentUser.getIdToken();

      const headers = new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      });

      const data = JSON.stringify({ credentials });

      console.log(`Sending data: ${data}`);

      const response = await firstValueFrom(
        this.http.post(environment.createUserDBWeb, data, {
          headers: headers,
          responseType: 'text',
        })
      );


      console.log('Creating user web response: ', response);
      this.logClientInfo('Creating user response: ' + JSON.stringify(response));

      return response;
    } catch (error) {
      console.error('Creating user web error: ', error);
      this.logErrors('Error creating user: ' + JSON.stringify(error));
      throw error;
    }
  }

  // onCall func 2.0
  async createUserCallable(credentials, user): Promise<any> {
    // Remove sensitive information from credentials
    delete credentials.password;

    // Reviews not needed for agents
    if (credentials.role === 'agent') {
      delete credentials.reviews;
    }

    const auth = getAuth();
    console.log(`Creating user via web ${user} with credentials: ${JSON.stringify(credentials)}`);

    try {

      // Prepare the data to send to the callable function
      const data = {
        credentials: credentials
      };

      // Call the Firebase Cloud Function
      const functions = getFunctions();
      const userCreateCallable = httpsCallable(functions, 'createUserCallable');
      const response = await userCreateCallable(data);

      console.log('Creating user callable response: ', response.data);

      return response.data;
    } catch (error) {
      console.error('Creating user callable error: ', error);

      // as a retry use the web server
      return this.createUserDBWeb(credentials, user);

      // throw error;
    }
  }



  checkUsernameAvailable(username): Promise<any> {
    return new Promise<any>((resolve, reject) => {

      if (!username.trim()) {
        reject('EMPTY_USERNAME');
      }

      const functions = getFunctions();
      const callable = httpsCallable(functions, 'checkUsernameCallable');
      // Call the callable function with the prompt as data
      callable({ micrositeUserId: username })
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          // Handle errors
          console.error('Error:', error);
          // Reject the Promise with the error
          reject(error);
        });
    });
  }

  // AGENT SENDS
  sendLenderConnectionInvite(lenderEmail, lenderId): Promise<any> {

    const self = this;

    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });

        const options = { headers: headers };

        const data = JSON.stringify({
          lenderEmail: lenderEmail || '',
          lenderId: lenderId || ''
        });

        console.log('sending data: ' + JSON.stringify(data));

        self.http.post(environment.inviteLender, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            if (res) {
              console.log('Connection invite response: ' + res);
              resolve(res);
            }
            else {
              console.error('Connection invite error : ' + JSON.stringify(res));
              this.logErrors('Error in agent inviting lender: ' + JSON.stringify(res));
              reject('error');
            }
          })
          .catch(error => {
            console.error('Connection invite error 2: ' + error);
            this.logErrors('Error in agent inviting lender 2: ' + error);
            reject(error);
          });
      }).catch(err => {
        console.log('failed to send invite 3: ' + err);
        this.logErrors('Error in lender inviting agent 3: ' + err);
        reject(err);
        // Handle error
      });
      // ...
    });
  }

  sendAgentAdminConnectionInvite(agentAdminEmail, agentAdminId): Promise<any> {

    const self = this;

    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });

        const options = { headers: headers };

        const data = JSON.stringify({
          agentAdminEmail: agentAdminEmail || '',
          adminId: agentAdminId || ''
        });

        console.log('sending data: ' + JSON.stringify(data));

        self.http.post(environment.inviteAgentAdmin, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            if (res) {
              console.log('Connection invite response: ' + res);
              resolve(res);
            }
            else {
              console.error('Connection invite error : ' + JSON.stringify(res));
              this.logErrors('Error in agent inviting agentAdmin: ' + JSON.stringify(res) + ' ' + JSON.stringify(data));
              reject('error');
            }
          })
          .catch(error => {
            console.error('Connection invite error 2: ' + error);
            this.logErrors('Error in agent inviting agentAdmin 2: ' + JSON.stringify(error) + ' ' + JSON.stringify(data));
            reject(error);
          });
      }).catch(err => {
        console.log('failed to send invite 3: ' + err);
        this.logErrors('Error in agentAdmin inviting agent 3: ' + err);
        reject(err);
        // Handle error
      });
      // ...
    });
  }

  // LENDER SENDS
  sendAgentConnectionInvite(agentEmail, agentId): Promise<any> {

    const self = this;

    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });

        const options = { headers: headers };

        const data = JSON.stringify({
          agentEmail: agentEmail || '',
          agentId: agentId || ''
        });

        console.log('sending data: ' + JSON.stringify(data));

        self.http.post(environment.inviteAgentEmail, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            if (res) {
              console.log('Connection invite response: ' + res);
              resolve(res);
            }
            else {
              console.error('Connection invite error : ' + JSON.stringify(res));
              this.logErrors('Error in lender inviting agent: ' + JSON.stringify(res));
              reject('error');
            }
          })
          .catch(error => {
            console.error('Connection invite error 2: ' + error);
            this.logErrors('Error in lender inviting agent 2: ' + error);
            reject(error);
          });
      }).catch(err => {
        console.log('failed to send invite 3: ' + err);
        this.logErrors('Error in lender inviting agent 3: ' + err);
        reject(err);
        // Handle error
      });
      // ...
    });
  }

  sendConnectionInvite(refCode, action): Promise<any> {

    console.log('action passed: ' + action);
    const self = this;

    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });

        const options = { headers: headers };

        const data = JSON.stringify({
          referralcode: refCode,
          action: action
        });

        console.log('sending data: ' + JSON.stringify(data));

        self.http.post(environment.connectionInvite, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection invite response: ', res);
            resolve(res);
          })
          .catch((error) => {
            console.error('Connection invite error : ', error);
            reject(error);
          });
      }).catch(error => {
        console.log('failed to send invite: ' + error);
        reject(error);
        // Handle error
      });

      // ...
    }).catch(err => {
      console.log('2 failed to send invite: ' + err);
      // Handle error
    });
  }

  declineConnectionInvite(targetUserId, action): Promise<any> {

    console.log('decline connection called for : ' + targetUserId + ' action: ' + action);
    const self = this;
    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          targetUserId: targetUserId,
          action: action
        });

        self.http.post(environment.connectionInvite, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection decline response: ', res);
            resolve(res);
          })
          .catch((error) => {
            console.error('Connection decline error : ', error);
            reject((<any>error));
          });
      }).catch(error => {
        console.log('failed to send invite: ' + error);
        reject(error);
        // Handle error
      });
    });
  }

  declineConnectionInviteLender(targetUserId, action): Promise<any> {

    console.log('decline connection called for : ' + targetUserId + ' action: ' + action);
    const self = this;
    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          targetUserId: targetUserId,
          action: action
        });

        self.http.post(environment.connectionInviteLender, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection decline response: ', res);
            resolve(res);
          })
          .catch((error) => {
            console.error('Connection decline error : ', error);
            reject((<any>error));
          });
      }).catch(error => {
        console.log('failed to send invite: ' + error);
        reject(error);
        // Handle error
      });
    });
  }

  acceptConnectionInviteLender(agentId, action): Promise<any> {

    const self = this;
    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS
        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          agentId: agentId,
          action: action
        });

        self.http.post(environment.connectionAcceptLender, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection accept response: ', res);
            resolve(res);
          })
          .catch(error => {
            console.error('Connection accept error : ', error);
            reject(error.error.toString());
          });
      }).catch(err => {
        console.log('failed to send connection accept: ' + err);
        reject(err.error.toString());
        // Handle error
      });
    });
  }


  acceptConnectionInvite(userId, action, type): Promise<any> {

    const self = this;
    return new Promise((resolve, reject) => {

      let url = environment.connectionAccept;

      if (User_global.role === 'agentAdmin') {
        url = environment.connectionAcceptAgentAdmin_Agent;
      }
      else if (type === 'agentAdmin') {
        url = environment.connectionAcceptAgentAdmin;
      }
      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS
        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          userId: userId,
          action: action
        });

        self.http.post(url, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection accept response: ', res);
            resolve(res);
          })
          .catch(error => {
            console.error('Connection accept error : ', error);
            reject(error.error.toString());
          });
      }).catch(err => {
        console.log('failed to send connection accept: ' + err);
        reject(err.error.toString());
        // Handle error
      });
    });
  }

  // userId is the user to unpair from
  unpairConnection(targetUserId, action?, type?): Promise<any> {
    console.log('unapir from ' + targetUserId + 'called');

    const self = this;
    let url = environment.connectionUnpair;

    if (type === 'agentAdmin') {
      url = environment.connectionUnpairAgentAdmin;
    }

    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS
        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          targetUserId: targetUserId
        });

        self.http.post(url, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection unpair response: ', res);
            resolve(res);
          })
          .catch((error) => {
            console.error('Connection unpair error : ', error);
            reject(error.error.toString());
          });
      }).catch(error => {
        console.log('failed to send connection unpair: ' + error);
        reject(error.error.toString());
        // Handle error
      });
    });
  }

  getAuthToken(): Promise<any> {
    console.log('refresh auth token called');

    const self = this;
    return new Promise((resolve, reject) => {

      const auth = getAuth();
      this.currentUser = auth.currentUser;

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS
        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = {};

        self.http.post(environment.getTokenRequest, data, options)
          .toPromise()
          .then((res) => {
            self.userAuthToken = JSON.parse(JSON.stringify(res)).token;

            resolve(res);
          })
          .catch((error) => {
            console.error('auth token error : ', error);
            reject(error);
          });
      }).catch(error => {
        console.log('failed to send token request: ' + error);
        reject(error);
        // Handle error
      });
    }).catch(error => {
      console.log('2 failed to send token request: ' + error);
      // Handle error
    });
  }

  setIntercomTag(email, tag_name): Promise<any> {

    console.log('tag passed: ' + tag_name + ' email passed: ' + email);

    const self = this;

    return new Promise((resolve, reject) => {

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS

        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = JSON.stringify({
          tag_email: email,
          tag_name: tag_name
        });

        console.log('sending data: ' + JSON.stringify(data));

        self.http.post(environment.intercom.tag_url, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('tag intercom response: ', res);
            resolve((<any>res));
          })
          .catch((error) => {
            console.error('tag intercom error : ', error);
            reject(error);
          });
      }).catch(error => {
        console.log('failed tag intercom: ' + error);
        reject(error);
        // Handle error
      });
      // ...
    }).catch(error => {
      console.log('2 failed to send invite: ' + error);
      // Handle error
    });
  }

  sendWebhook(webhook, payload): Promise<any> {

    const headers = new HttpHeaders(
      {
        'Content-Type': 'text/plain'
      });
    const options = { headers: headers };

    const data = JSON.stringify({ payload: payload });

    return new Promise((resolve, reject) => {
      this.http.post(webhook, data, { ...options, responseType: 'text' })
        .toPromise()
        .then((res) => {
          console.log('WEBHOOK RESPONSE : ', res);
          resolve((<any>res));
        })
        .catch((error) => {
          console.error('WEBHOOK Error : ', error);
          reject(error);
        });
    });
  }

  sendUserInvite(url, payload): Promise<any> {
    const self = this;
    return new Promise((resolve, reject) => {

      const auth = getAuth();
      this.currentUser = auth.currentUser;

      this.currentUser.getIdToken().then((idToken) => {
        // Send token to your backend via HTTPS
        const headers = new HttpHeaders(
          {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          });
        const options = { headers: headers };

        const data = payload;

        self.http.post(url, data, { ...options, responseType: 'text' })
          .toPromise()
          .then((res) => {
            console.log('Connection accept response: ', res);
            resolve(res);
          })
          .catch((error) => {
            console.error('Connection accept error : ', error);
            reject(error.error.toString());
          });
      }).catch(error => {
        console.log('failed to send connection accept: ' + error);
        reject(error.error.toString());
        // Handle error
      });
    });
  }

  public formatDate(date) {
    const monthNames = [
      'January', 'February', 'March',
      'April', 'May', 'June', 'July',
      'August', 'September', 'October',
      'November', 'December'
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return `${monthNames[monthIndex]} ${day} ${year}`;
  }


  formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    const strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  getNewGuestId() {
    const auth = getAuth();

    if (!this.currentUser || this.currentUser.uid) {
      this.currentUser = {};
      this.currentUser.uid = auth.currentUser?.uid || localStorage.getItem('uid');
    }

    const firestore = getFirestore();
    const collectionRef = collection(firestore, API.users_endpoint, this.currentUser.uid, API.guests_endpoint);
    const newDocRef = doc(collectionRef);
    return newDocRef.id;
  }

  async updateGuestSurvey(guestData: SurveyData, docId?: any, offline = false): Promise<any> {
    try {
      console.log(
        'updateGuestSurvey: ' + JSON.stringify(guestData) + ' ' + docId +
        ' offline ' + offline + ' this.currentUser.uid ' + this.currentUser?.uid
      );

      let loggedInUser = this.getUID();

      if (!loggedInUser) {
        //loggedInUser = '';
        this.logErrors('NO_LOGGED_IN_USER: ' + ' payload: ' + 'updateGuestSurvey: ' + JSON.stringify(guestData) + ' docId:' + docId +
          ' offline ' + offline + ' loggedInUser ' + this.getUID());

        return Promise.reject('NO_LOGGED_IN_USER');
      }

      const firestore = getFirestore();
      const collectionRef = collection(firestore, API.users_endpoint, loggedInUser, API.guests_endpoint);

      if (!guestData.createdAt) {
        const createdDate = new Date(guestData.createdDate);
        guestData.createdAt = this.formatDate(createdDate);
        guestData.time = this.formatAMPM(createdDate);
      }

      if (docId) {
        const guestDoc = doc(collectionRef, docId);
        await setDoc(guestDoc, guestData, { merge: true });
        console.log('Document successfully updated');
        return Promise.resolve(docId);  // Return the resolved docId
      } else {
        const newDocRef = await addDoc(collectionRef, guestData);
        console.log('New document successfully created');
        return Promise.resolve(newDocRef.id);  // Return the new document ID
      }
    } catch (error) {

      const formattedError = error.message ? error.message + ' ' + JSON.stringify(error.stack) : JSON.stringify(error);

      console.error('Error: ', error);
      this.logErrors('Error updating or creating guest: ' + formattedError + ' payload: ' + 'updateGuestSurvey: ' + JSON.stringify(guestData) + ' docId:' + docId +
        ' offline ' + offline + ' loggedInUser ' + this.getUID());

      return Promise.reject(error);  // Return a rejected Promise with the error
    }
  }

  subscribeToUser(userId: string): Observable<any> {
    const db = getFirestore();
    const userDocRef = doc(collection(db, API.users_endpoint), userId);

    console.log('Subscribing to user: ' + userId);

    return new Observable<any>(observer => {
      const unsubscribe = onSnapshot(
        userDocRef,
        docSnapshot => {
          if (docSnapshot.exists()) {
            observer.next(docSnapshot.data());
          } else {
            observer.error(new Error('No such document! ' + userId + ' ' + userDocRef));
          }
        },
        error => {
          observer.error(error);
        }
      );

      // Store unsubscribe function
      const subscriptionId = `subscribeUser_${userId}_${Date.now()}`;
      this.activeSubscriptions.set(subscriptionId, unsubscribe);

      return () => {
        console.log('Unsubscribing from user document listener');
        const cleanup = this.activeSubscriptions.get(subscriptionId);
        if (cleanup) {
          cleanup();
          this.activeSubscriptions.delete(subscriptionId);
        }
      };
    }).pipe(
      takeUntil(this.destroy$)
    );
  }


  getMyLatestListings(): Observable<any> {
    const db = getFirestore();
    const auth = getAuth();

    return new Observable((observer) => {
      let listingsUnsubscribe: (() => void) | null = null;

      const authUnsubscribe = onAuthStateChanged(auth, (user) => {
        // Clean up previous listings listener
        if (listingsUnsubscribe) {
          listingsUnsubscribe();
          listingsUnsubscribe = null;
        }

        if (user) {
          const listingsCollectionRef = collection(
            db,
            `${API.users_endpoint}/${user.uid}/${API.listings_endpoint}`
          );
          const queryRef = query(listingsCollectionRef, orderBy('createdAt', 'desc'), limit(1));

          listingsUnsubscribe = onSnapshot(queryRef, (snapshot) => {
            if (!snapshot.empty) {
              const listingDoc = snapshot.docs[0];
              const listingId = listingDoc.id;
              const listingData = listingDoc.data() as Listing;
              observer.next({ success: true, listingId, listingData });
            } else {
              observer.next({ success: false });
            }
          }, (error) => {
            observer.error(error);
          });
        } else {
          observer.next({ success: false });
        }
      });

      // Store unsubscribe functions
      const subscriptionId = `latestListings_${Date.now()}`;
      this.activeSubscriptions.set(subscriptionId, () => {
        authUnsubscribe();
        if (listingsUnsubscribe) {
          listingsUnsubscribe();
        }
      });

      return () => {
        const cleanup = this.activeSubscriptions.get(subscriptionId);
        if (cleanup) {
          cleanup();
          this.activeSubscriptions.delete(subscriptionId);
        }
      };
    }).pipe(
      first(),
      catchError((error) => of({ success: false, error })),
      takeUntil(this.destroy$)
    );
  }

  async checkUserBackNavigation() {
    console.log('Checking for logged in user');
    const user = await this.isLoggedIn();
    const userRole = User_global.role;
    if (user && userRole === 'lender') {
      this.router.navigate(['/my-paired-agents'], { replaceUrl: true });
    } else if (user && userRole === 'agent') {
      this.router.navigate(['/my-listings'], { replaceUrl: true });
    } else if (user && userRole === 'agentAdmin') {
      //agentAdmin
      this.router.navigate(['/my-paired-agents'], { replaceUrl: true });
    }
    else {
      return;
    }
  }

  async getUserDocumentById(userId: string): Promise<WithId<CurbUser>> {
    const userDoc = doc(getFirestore(), `${API.users_endpoint}/${userId}`);
    const user = (await getDoc(userDoc)).data() as CurbUser

    return {
      id: userId,
      ...user
    }
  }

  async getCurrentFullUser(): Promise<WithId<CurbUser>> {
    await firstValueFrom(
      this.userInitialized$.pipe(
        filter(initialized => !!initialized),
        timeout(30000)
      )
    );

    return { ...User_global, id: this.getUID() };
  }

  async getFullUser(numberOfRetries = 0): Promise<WithId<CurbUser>> {
    if (numberOfRetries > 3) {
      console.error('Too many retries when trying to get the current user');
      throw new Error('No user found');
    }

    if (this.currentUser) {
      return this.getUserDocumentById(this.currentUser.uid);
    } else {
      return new Promise<WithId<CurbUser>>((resolve, reject) => {
        const unsubscribe = onAuthStateChanged(getAuth(), async (user) => {
          unsubscribe(); // Clean up immediately

          if (user) {
            try {
              const userData = await this.getUserDocumentById(user.uid);
              resolve(userData);
            } catch (error) {
              reject(error);
            }
          } else {
            setTimeout(() => {
              this.getFullUser(numberOfRetries + 1)
                .then(resolve)
                .catch(reject);
            }, 1000);
          }
        });
      });
    }
  }


  getHeaders() {

    this.currentUser = getAuth().currentUser;

    return {
      "Authorization": `Bearer ${this.currentUser.accessToken}`
    }
  }

  _isUserImpersonatingCache = undefined;
  async isUserImpersonating() {
    if (this._isUserImpersonatingCache === undefined) {
      // The "originalUserId" claim will only be present if we are in fact impersonating an user
      this._isUserImpersonatingCache = (await getAuth().currentUser.getIdTokenResult())?.claims?.originalUserId || false;
    }

    return this._isUserImpersonatingCache;
  }

  async canCurrentUserImpersonate() {
    if ((User_global.isSuperUser || User_global.role === 'agentAdmin') && !await this.isUserImpersonating()) {
      return true;
    } else {
      return false;
    }
  }

  async isCurrentUserSuperUser() {
    if (!this.currentUser?.accessToken) {
      return;
    }

    return User_global.isSuperUser;
  }

  // After calling this method you need to refresh the page to see the changes
  async impersonateUser(userToImpersonate: string) {
    if (!this.currentUser?.accessToken) {
      return;
    }

    try {
      const response = await this.http
        .post<{ customToken: string }>(
          environment.impersonateUser,
          {
            targetUserId: userToImpersonate,
          },
          { headers: this.getHeaders() }
        )
        .toPromise();



      const userCredential = await signInWithCustomToken(getAuth(), response.customToken);

      localStorage.setItem('uid', userCredential.user.uid);

      return true
    } catch (error) {
      console.log('Error impersonating user: ', error)
      return false
    }
  }

  async removeUserImpersonation() {
    if (!this.currentUser?.accessToken) {
      return
    }

    try {
      // The backend will return a new token for the original user
      const response = await this.http.post<{ customToken: string }>(environment.removeUserImpersonation, {}, { headers: this.getHeaders() },).toPromise();

      const userCredential = await signInWithCustomToken(getAuth(), response.customToken);
      localStorage.setItem('uid', userCredential.user.uid);

      return true
    } catch (error) {
      console.log('Error removing user impersonation: ', error)
      return false;
    }
  }

  saveLogToLocalStorage(type, args = []) {
    if (!environment.enableDebugMenu) {
      return;
    }

    const argsAsString = args.map(arg => {
      try {
        return typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
      } catch (e) {
        return '[Unserializable]';
      }
    }).join(' ')
    const entry = `${type} | (${new Date().toISOString()}) | ${argsAsString} \n`

    let existingLogs = localStorage.getItem(DEBUG_LOGS_KEY) || '';
    let combined = existingLogs + entry;

    if (this.getStringSizeInMB(combined) > MAX_LOGS_IN_MB) {
      combined = combined.slice(0, combined.length / 3)
    }

    localStorage.setItem(DEBUG_LOGS_KEY, combined);
  }

  getStringSizeInMB(str = '') {
    const bytes = new TextEncoder().encode(str).length;
    return bytes / (1024 * 1024)
  }
}